/**
 * Get Query From URL
 *
 * @param {string} search
 *
 * @returns {Object}
 */
const getQuery = (search) => {
    let query = {};

    if (search !== '') {
        search.slice(1).split('&').forEach((item) => {
            const [key, value] = item.split('=');

            query[key] = value;
        });
    }

    return query;
};

export default getQuery;
